
export const Manual = () => {
  return(
    <div className="div-primary-color p-20">
      <div className="container">
        This is manual page.
      </div>
    </div>
  )
}